import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useUpdateSearchProperties = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_SEARCH_PROPERTIES, category, code, properties,
  }), [category, code]);
};

const usePerformFind = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({
    append, page, pageSize, query, filter,
  }) => handler({
    type: actions.FIND, category, code, append, page, pageSize, query, filter,
  }), [category, code]);
};

const useDecodeSearchQuery = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ query }) => handler({
    type: actions.DECODE_SEARCH_QUERY, category, code, query,
  }), [category, code]);
};

export default {
  useDecodeSearchQuery,
  usePerformFind,
  useUpdateSearchProperties,
};
